<h3 mat-dialog-title>What's new in &nbsp; T I M E S H E E T S &nbsp; ?</h3>
<mat-dialog-content class="releases">
    <div class="release" *ngFor="let release of releases">
        <span class="release-title">{{ release.version }}</span>
        <code>
            <ng-container *ngFor="let content of release.content">- {{ content }}<br /></ng-container>
        </code>
    </div>
</mat-dialog-content>
